import React from 'react';
import PropTypes from 'prop-types';

import SimpleCheckbox from '../simpleCheckbox';

const PermissionCheckbox = ({
  id,
  name,
  onChange,
  tooltip,
  colSpan,
  disabled,
}) => (
  <td className="c-table-permissions--permission-checkbox" colSpan={colSpan}>
    <div className="u-inline-block c-info-tooltip-new-handler" data-automation-id={name}>
      <SimpleCheckbox
        display-if={id && name}
        id={id}
        name={name}
        onChange={onChange}
        disabled={disabled}
      />
      <div
        className="c-info-tooltip-new__content"
        display-if={!!tooltip}
      >
        {tooltip}
      </div>
    </div>
  </td>
);

PermissionCheckbox.propTypes = {
  colSpan: PropTypes.number,
  name: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  tooltip: PropTypes.string,
  // Array of permission names that have to be given to the user in order to be able to give this permission.
  // Permissions in 'requires' array will be automatically turned ON when this permission is turned ON.
  // eslint-disable-next-line react/no-unused-prop-types
  requires: PropTypes.arrayOf(PropTypes.string),
  // Array of permission names that cannot be given to the user if this permission is not given.
  // Permissions in 'requiredFor' array will be automatically turned OFF when this permission is turned OFF.
  // eslint-disable-next-line react/no-unused-prop-types
  requiredFor: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

PermissionCheckbox.defaultProps = {
  colSpan: 1,
  id: null,
  name: null,
  onChange: null,
  tooltip: null,
  requires: null,
  requiredFor: null,
  disabled: false,
};

export default PermissionCheckbox;
